<template>
  <div class="background">
    <div class="container">
      <div class="welcome-section">
        <h1>Welcome back</h1>
        <p>
          Lorem ipsum is placeholder text commonly used in the graphic, print,
          and publishing industries for previewing layouts and visual mockups
        </p>
      </div>
      <div class="login-section">
        <div class="login-box">
          <div class="header">
            <h3>Sign In</h3>
          </div>
          <div class="form">
            <input
              type="text"
              placeholder="Username"
              class="input"
              v-model="username"
              :class="{ 'input-error': errors.username }"
            />
            <span v-if="errors.username" class="error-message">{{
              errors.username
            }}</span>
            <div class="password-container">
              <input
                type="password"
                placeholder="Password"
                class="input"
                v-model="password"
                :class="{ 'input-error': errors.password }"
              />
              <span v-if="errors.password" class="error-message">{{
                errors.password
              }}</span>
            </div>
            <span v-if="errors.fullerror" class="error-message">{{
              errors.fullerror
            }}</span>
            <button
              type="submit"
              :disabled="loading"
              :style="{ backgroundColor: loading ? '#6B7280' : '' }"
              class="submit-button"
              @click="validateForm"
            >
              {{ !loading ? "Sign in" : "Loading..." }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <svg
      class="background-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 320"
    >
      <path
        fill="#fff"
        fill-opacity="1"
        d="M0,0L40,42.7C80,85,160,171,240,197.3C320,224,400,192,480,154.7C560,117,640,75,720,74.7C800,75,880,117,960,154.7C1040,192,1120,224,1200,213.3C1280,203,1360,149,1400,122.7L1440,96L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"
      ></path>
    </svg>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted, watch } from "vue";

// Api
import axios from "axios";
import { getBaseUrl } from "@/helper/constant.js";
import { login } from "../stores/auth.ts";

const showPassword = ref(false);

const username = ref("");
const password = ref("");
const errors = ref({ username: "", password: "", fullerror: "" });
const loading = ref(false);

const validateForm = async () => {
  errors.value = { username: "", password: "", fullerror: "" };
  if (!username.value) {
    errors.value.username = "Username is required";
  }
  if (!password.value) {
    errors.value.password = "Password is required";
  }

  if (!errors.value.username && !errors.value.password) {
    try {
      loading.value = true;
      const response = await login(username.value, password.value);
      if (response === false) {
        errors.value.fullerror = "Invalid username or password";
      }
    } catch (error) {
      console.log(error);
    } finally {
      loading.value = false;
    }
  }
};
</script>

<style>
.background {
  background: linear-gradient(to bottom, #1a202c, #1a202c, #6b46c1);
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: transparent;
  border-radius: 1.5rem;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

.welcome-section {
  display: none;
  flex-direction: column;
  color: #d1d5db;
  padding: 0 3.5rem;
  max-width: 32rem;
}

.welcome-section h1 {
  margin-bottom: 1rem;
  font-size: 2.25rem;
  font-weight: 600;
}

.welcome-section p {
  padding-right: 0.75rem;
  font-size: 0.875rem;
  opacity: 0.75;
}

.login-section {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.login-box {
  padding: 3rem;
  background: #fff;
  border-radius: 1.5rem;
  width: 24rem;
}

.header {
  margin-bottom: 1.75rem;
}

.header h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
}

.header p {
  color: #9ca3af;
}

.header a {
  font-size: 0.875rem;
  color: #6b46c1;
  transition: color 0.3s;
}

.header a:hover {
  color: #6b46c1;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.input {
  width: 100%;
  font-size: 0.875rem;
  padding: 0.75rem 1rem;
  background: #e5e7eb;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  outline: none;
  transition:
    background 0.3s,
    border-color 0.3s;
}

.input:focus {
  background: #f3f4f6;
  border-color: #6b46c1;
}

.input-error {
  border-color: red;
}

.error-message {
  color: red;
  font-size: 0.875rem;
}

.password-container {
  position: relative;
}

.toggle-password {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  cursor: pointer;
}

.show-password,
.hide-password {
  width: 1rem;
  height: 1rem;
  color: #6b46c1;
}

.forgot-password {
  display: flex;
  justify-content: flex-end;
}

.forgot-password a {
  font-size: 0.875rem;
  color: #6b46c1;
  transition: color 0.3s;
}

.forgot-password a:hover {
  color: #6b46c1;
}

.submit-button {
  width: 100%;
  display: flex;
  justify-content: center;
  background: #6b46c1;
  color: #f3f4f6;
  padding: 0.75rem;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
}

.submit-button:hover {
  background: #5a3b9a;
}

.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 1.25rem 0;
}

.divider span {
  height: 1px;
  width: 4rem;
  background: #f3f4f6;
}

.social-login {
  display: flex;
  justify-content: center;
  gap: 1.25rem;
}

.google-login,
.facebook-login {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  color: #6b7280;
  cursor: pointer;
  transition:
    border-color 0.3s,
    background 0.3s;
}

.google-login:hover,
.facebook-login:hover {
  border-color: #1f2937;
  background: #1f2937;
  color: #f3f4f6;
}

.icon {
  width: 1rem;
  margin-right: 0.5rem;
}

.footer {
  background: transparent;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 30;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  padding: 1.25rem;
}

.footer-content a {
  display: flex;
  align-items: center;
  color: #4b5563;
  text-decoration: none;
}

.footer-content img {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  object-fit: cover;
}

.footer-content p {
  font-size: 1.25rem;
  margin-left: 0.5rem;
}

.footer-content p strong {
  font-weight: 700;
}

.background-svg {
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>
